window.addEventListener('DOMContentLoaded', () => {
    new Swiper('.swiper.collections__container', {
        slidesPerView: 2.33,
        spaceBetween: 5,
        // Responsive breakpoints
        breakpoints: {
            1024: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            1440: {
                slidesPerView: 6,
                spaceBetween: 10,
            }
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        keyboard: {
            enabled: true,
        }
    });

    console.log('collections section swiper builded');
});
